import { render, staticRenderFns } from "./ApproveSteps.vue?vue&type=template&id=680a4c66&scoped=true&"
import script from "./ApproveSteps.vue?vue&type=script&lang=js&"
export * from "./ApproveSteps.vue?vue&type=script&lang=js&"
import style0 from "./ApproveSteps.vue?vue&type=style&index=0&id=680a4c66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a4c66",
  null
  
)

export default component.exports